import React, { useContext } from "react";

/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
//import Main from './layouts/Main';

import ScrollToTop from "./layouts/ScrollToTop";
// ----------------------------------------------------------------------------------
/// Dashboard

// import Home from "./components/Dashboard/Home";
import Home from "../jsx/pages/Dashboard/Dashboard";

//online payment 
    import SubscriptionOnlinePayment from "./pages/Subscription_Management/Manage_Subscriptions/PaymentOnline";
    
// ----------------------------------------------------------------------------------

// Branch Management
  import ManageBranch from "./pages/Branch_Management/Manage_Branch/Branch";
  import AddBranch from "./pages/Branch_Management/Manage_Branch/AddBranch";
  import EditBranch from "./pages/Branch_Management/Manage_Branch/EditBranch";
  import ManageArea from "./pages/Branch_Management/Manage_Area/Area";
  import ManageDeliveryPoint from "./pages/Branch_Management/Manage_Delivery_Point/Delivery_Point";
  import ManageAddStaff from "./pages/Branch_Management/Manage_Branch/AddStaff";
  
  import ManageCalls from './pages/Lead_Management/Manage_Calls/Manage_Calls';
    import LeadCalendar from './pages/Lead_Management/Manage_Lead_Calendar/Lead_Calendar';
    import ManageLeadSource from './pages/Lead_Management/Manage_Lead_Source/Manage_Lead_Source';
    
import ManageExitStaffs from "./pages/HR_Management/Manage_Staff/StaffExitList";

import ViewProductQuantity from './pages/Production_Management/Item_Quantity/Manage_Product_Quantity';

import Pages from "./pages/Production_Management/Manage_Delivery_sheet/page";
  import ManageCatCorpMenu from "./pages/Catering_Corp_Menu_Management/Menu/Catering_Corp_Menu";
 
 
// Lead Management

    // Manage Lead
    import ManageLead from "./pages/Lead_Management/Manage_Lead/Lead";
    import ManageCoupon from "./pages/Lead_Management/Manage_Coupon/Coupon";

    import ManageDelivery from "./pages/Delivery_Management/Manage_Delivery/Delivery";
     import ManageTracking from "./pages/Delivery_Management/Manage_Tracking/Manage_Tracking";
     import Redeem from "./pages/Lead_Management/Manage_Coupon/Redeem";
     import SpamReason from "./pages/Settings/Lead_Management/SpamReason/SpamReason";
      import DeadReason from "./pages/Settings/Lead_Management/DeadReason/DeadReason";
      import InternallCall from "./pages/Settings/Lead_Management/InternalCalls/InternalCalls";
    import ManageAppointment from "./pages/Lead_Management/Manage_Appointment/Manage_Appointment";
    import ManageFollowup from "./pages/Lead_Management/Manage_Followup/ManageFollowup";
import ManageCloudCall from './pages/Lead_Management/Manage_Cloud_Call/Manage_Cloud_Calls';

import SpamLead from './pages/Lead_Management/Manage_Lead/SpamVerification';
    import DeadLead from './pages/Lead_Management/Manage_Lead/DeadVerification';
    import InternalCall from './pages/Lead_Management/Manage_Lead/InternalCall';
    import TodayFollowup from './pages/Lead_Management/Manage_Lead/ManageFollowup';
    import Followupreason from "./pages/Settings/Lead_Management/FollowupReason/FollwupReason";
    
  // Team Management
  import TeamLead from "./pages/Team_Management/Team_Lead/TeamLead";
  import TeamFollowup from "./pages/Team_Management/Team_Lead/TeamFollowup";
  import TeamAppointment from "./pages/Team_Management/Team_Lead/TeamAppointment";
  import TeamCall from "./pages/Team_Management/Team_Lead/TeamCall";
  import TeamPromise from "./pages/Team_Management/Team_Lead/TeamPromise";
  import TeamPromiseMonth from "./pages/Team_Management/Team_Lead/TeamPromise_month";

// manage order
    import ManageOrder from './pages/Subscription_Management/Manage_Order/ManageOrder';
    import AddSubscriptions from './pages/Subscription_Management/Manage_Order/AddSubscriptions';
    import ViewSubscriberDetails from './pages/Subscription_Management/Manage_Order/ViewSubscriberdetails';
    import ViewCustomer from './pages/Catering_Management/Manage_customer/View_Customer';


    
    
// ----------------------------------------------------------------------------------
// Subscription Management

    // Manage Customers
    import ManageSubscribers from "./pages/Subscriber_Management/Manage_Subscriber/Subscribers";
    import ViewSubscribers from "./pages/Subscriber_Management/Manage_Subscriber/ViewSubscriber";
    import FoodMap from "./pages/Subscriber_Management/Manage_Subscriber/FoodMap";
    import NewSubscriptions from "./pages/Subscriber_Management/Manage_Subscriber/NewSubscriptions";

    // Manage Subscription
    import ManageSubscription from "./pages/Subscription_Management/Manage_Subscriptions/Subscription";
    import LeadtoSubscription from "./pages/Subscription_Management/Manage_Subscriptions/LeadtoSubscription";
    // import AddSubscription from "./pages/Subscription_Management/Manage_Subscriptions/AddSubscription";
    import ConvertSubscriber from "./pages/Subscription_Management/Manage_Subscriptions/ConvertSubscriber";
    import RenewSubscription from "./pages/Subscription_Management/Manage_Subscriptions/RenewSubscription";
    import ConvertnewSubscriber from "./pages/Subscriber_Management/Manage_Subscriber/ConvertSubscriber";


import SubDepartment from "./pages/Settings/HR_Management/SubDepartment/SubDepartment";
import Level from "./pages/Settings/HR_Management/Level/Level";



// hold
    import ManageHold from './pages/Subscription_Management/Manage_Hold/Hold'
    
    // Manage Drop
    import ManageDrop from './pages/Subscription_Management//Manage_Drop/Drop'

// ----------------------------------------------------------------------------------
  //Packages Management

    // Manage Products
    import ManageProducts from "./pages/Packages_Management/Manage_Products/Products";
    import AddProduct from "./pages/Packages_Management/Manage_Products/AddProduct";
    import EditProduct from "./pages/Packages_Management/Manage_Products/EditProduct";
     // Manage Item Quantity
    //  import Item_Quantity from "./pages/Packages_Management/Manage_Item_Quantity/Item_Quantity";
     
    // Manage Packages
    import ManagePackages from "./pages/Packages_Management/Manage_Packages/Packages";

    // Manage Megamenu
    import ManageMenuMaker from "./pages/Packages_Management/Manage_Megamenu/ManageMenu";
    import AddMenuMaker from "./pages/Packages_Management/Manage_Megamenu/AddMenu";
    import EditMenuMaker from "./pages/Packages_Management/Manage_Megamenu/EditMenu";
// ----------------------------------------------------------------------------------
  //Payment Management

    import ManagePayments from "./pages/Payments_Management/Payments";
    import CateringPayments from "./pages/Payments_Management/CateringPayments";
    import CorporatePayments from "./pages/Payments_Management/CorporatePayments";
    import ManageRefund from "./pages/Payments_Management/Manage_Refunds/Refund";
    import CateringRefund from "./pages/Payments_Management/Manage_Refunds/CateringRefund";
    import CorporateRefund from "./pages/Payments_Management/Manage_Refunds/CorporateRefund";
// ----------------------------------------------------------------------------------

import ClosedFollowup from './pages/Lead_Management/Manage_Followup/ManageFollowup_closed';
    import RescheduleFollowup from './pages/Lead_Management/Manage_Followup/ManageFollowup_reschedule';
    import UnFollowup from './pages/Lead_Management/Manage_Followup/ManageFollowup_unfollowup';
  import Manage_Forecast_Metrics from "./pages/Metrics_Management/Manage_Forecast_Metrics/Manage_Forecast_Metrics";
 
    
 import ManageFoodWastage from './pages/Production_Management/Manage_Wastage/Manage_FoodWastage'
 
// ----------------------------------------------------------------------------------
        // manage machinery
        import ManageMachinery from "./pages/Vehicle_Management/Manage_Machinery/Machinery";
        import AddMachinery from "./pages/Vehicle_Management/Manage_Machinery/AddMachinery";
        import EditMachinery from "./pages/Vehicle_Management/Manage_Machinery/EditMachinery";
        import ViewMachinery from "./pages/Vehicle_Management/Manage_Machinery/ViewMachinery";

  //Production Management


      import ViewItemQuantity from './pages/Production_Management/Item_Quantity/Manage_Item_Quantity';


    // Menu maker
  import MenuMaker from "./pages/Production_Management/Mega_Menu/Mega_Menu";
  import MenuMakerPrint from "./pages/Production_Management/Mega_Menu/MenuMakerPrint";
  // Manage Daily Orders
  // import ManageDailyOrders from "./pages/Production_Management/Manage_Daily_Orders/Daily_Orders";
  // Manage Works
  // import ManageWorks from "./pages/Production_Management/Manage_Works/Works";
  // Manage Quality Analysis
  // import ManageQualityAnalysis from "./pages/Production_Management/Manage_Quality_Analysis/Quality_Analysis";
  // Manage Wastage
  import ManageWastage from './pages/Production_Management/Manage_Wastage/Manage_Wastage';
  // Manage Production Costing
  import ManageProductionCosting from './pages/Production_Management/Manage_Production_Costing/Manage_Production_Costing'

  import QualityChecklistPriority from './pages/Settings/Production_Management/Quality_Checklist_Priority/Quality_Checklist_Priority';
  import ItemStagingProcess from "./pages/Settings/Production_Management/Staging_Process_Name/Staging_Process_Name";
     // Manage Items
        import ManageItems from "./pages/Production_Management/Manage_Items/Items";
        import ViewItems from './pages/Production_Management/Manage_Items/ViewItem';
        import AddItems from "./pages/Production_Management/Manage_Items/AddItem";
        import EditItems from "./pages/Production_Management/Manage_Items/EditItem";

      // Manage Daily Orders
        // import ManageDailyOrders from "./pages/Production_Management/Manage_Daily_Orders/Daily_Orders";

      // Manage Works
        import ManageWorks from "./pages/Production_Management/Manage_Works/Works";

      // Manage Quality Analysis
        import ManageQualityAnalysis from "./pages/Production_Management/Manage_Quality_Analysis/Quality_Analysis";
        
        import AmtEntryPurchase from "./pages/Purchase_Management/Manage_Purchase/AmtEntry";



// ----------------------------------------------------------------------------------

  // Vehicle Management

      // Manage Vehicles
        import ManageVehicles from "./pages/Vehicle_Management/Manage_Vehicle/Vehicles";
        import AddVehicle from "./pages/Vehicle_Management/Manage_Vehicle/AddVehicle";
        import EditVehicle from "./pages/Vehicle_Management/Manage_Vehicle/EditVehicle";
        import ViewVehicle from "./pages/Vehicle_Management/Manage_Vehicle/ViewVehicle";

      // Manage Vehicle Maintenance
        import ManageMaintenance from "./pages/Vehicle_Management/Manage_Maintenance/Maintenance";

// ----------------------------------------------------------------------------------

  // Delivery Management

      //Manage TripSheet
        import ManageTripsheet from "./pages/Delivery_Management/Manage_Tripsheet/Tripsheet";
        import PrintTripsheet from "./pages/Delivery_Management/Manage_Tripsheet/PrintTripsheet";

      // Manage Delivery
       // import ManageDelivery from "./pages/Delivery_Management/Manage_Delivery/Delivery";

// ----------------------------------------------------------------------------------

  // Complaints Management

      //Manage Complaints
        import ManageComplaints from "./pages/Complaints_Management/Manage_Complaints/Complaints";

// import AddonService from './pages/Settings/Catering_Management/AddonService/AddonService';
import LeaveType from "./pages/Settings/HR_Management/Leave_type/Leave_Type";
    import MenuManagement from './pages/Settings/Menu_Management/Menu_Management';
// ----------------------------------------------------------------------------------

  // Catering Management

      //Manage Catering
      import ManageCatering from "./pages/Catering_Management/Manage_Catering/Catering";

// ----------------------------------------------------------------------------------

  // Corporates Management

      //Manage Corporates
      import ManageCorporate from "./pages/Corporate_Management/Manage_Corporate/Corporate";

// ----------------------------------------------------------------------------------

  // HR Management

      //Manage Staffs
      import ManageStaffs from "./pages/HR_Management/Manage_Staff/Staff";
      import AddStaff from "./pages/HR_Management/Manage_Staff/AddStaff";
      import EditStaff from "./pages/HR_Management/Manage_Staff/EditStaff";
      import ViewStaff from "./pages/HR_Management/Manage_Staff/ViewStaff";

      //Manage Attendance
      import Attendance from "./pages/HR_Management/Manage_Attendance/Attendance";
      import AddAttendance from './pages/HR_Management/Manage_Attendance/Add_Attendance'

      //Manage Payouts
      import Payouts from "./pages/HR_Management/Manage_Payouts/Payouts";

// ----------------------------------------------------------------------------------
import CookwareCategory from '../jsx/pages/Settings/CookWare_Management/CookwareCategory';
import CookwareSubcategory from '../jsx/pages/Settings/CookWare_Management/CookwareSubcategory';
import CookwareMaterial from '../jsx/pages/Settings/CookWare_Management/CookwareMaterial';
import Cookware from '../jsx/pages/Settings/CookWare_Management/Cookware';
import MechCatego from '../jsx/pages/Settings/Vehicle_Management/Machinery_Category/MachineryCategory';

  // Accounts Management

      //Daily Accounts
      import DailyAccounts from "./pages/Accounts_Management/Daily_Accounts/Daily_Accounts";

      //Manage Profit Loss
      import ProfitLoss from "./pages/Accounts_Management/Profit_Loss/Profit_Loss";

      //Manage Trial Balance
      import TrialBalance from "./pages/Accounts_Management/Trial_Balance/Trial_Balance";

// ----------------------------------------------------------------------------------

  // Users Management

    import ManageUsers from "./pages/Users_Management/Manage_Users/Users";

      //Manage Users role
      import ManageUsersrole from "./pages/Users_Management/Manage_User_Role/Users";
      import AddUsers from "./pages/Users_Management/Manage_User_Role/AddUsers";
      import EditUsers from "./pages/Users_Management/Manage_User_Role/EditUsers";
      import ViewUsers from "./pages/Users_Management/Manage_User_Role/ViewUsers";


// ----------------------------------------------------------------------------------

  // Settings

      import GeneralSettings from "../jsx/pages/Settings/GeneralSettings";
      import Settings from "../jsx/pages/Settings/Settings";
      import Holiday from "../jsx/pages/Settings/Holiday";
      import Banner from "../jsx/pages/Settings/Banner";
      import MealsPoint from "../jsx/pages/Settings/MealsPoint";

      //  Common settings

      import Country from "../jsx/pages/Settings/Common_Settings/Country/Country";
      import State from "../jsx/pages/Settings/Common_Settings/State/State";
      import City from "../jsx/pages/Settings/Common_Settings/City/City";
      import TimeZoneFormat from "../jsx/pages/Settings/Common_Settings/TimeZone_Format/TimeZoneFormat";
      import CurrencyFormat from "../jsx/pages/Settings/Common_Settings/Currency_Format/CurrencyFormat";
      import Language from "../jsx/pages/Settings/Common_Settings/Language/Language";

      // Lead Management

      import LeadType from "./pages/Settings/Lead_Management/Lead_Type/LeadType";
      import LeadSource from "./pages/Settings/Lead_Management/Lead_Source/LeadSource";
      import LeadStatus from "./pages/Settings/Lead_Management/Lead_Status/LeadStatus";

      // subscription
      import DropReason from "./pages/Settings/Subscription_Management/DropReason/DropReason";

      // Production Management
      import Temperature from './pages/Settings/Production_Management/Temperature/Temperature'
      import Duration from './pages/Settings/Production_Management/Duration/Duration'
      import PreparationCategory from './pages/Settings/Production_Management/Preparation_Category/Preparation_Category'
      import PropertyType from './pages/Settings/Production_Management/ItemPropertyType/ItemPropertyType'
      import Property from './pages/Settings/Production_Management/Property/Property';
      


      //  Purchase Manangement

      import RawMaterialCategory from "./pages/Settings/Purchase_Management/Raw_Material_Category/RawMaterialCategory";
      import RawMaterialSubCategory from "./pages/Settings/Purchase_Management/Raw_Material_Sub_Category/RawMaterialSubCategory";
      import Units from "./pages/Settings/Purchase_Management/Units/Units";
      import VendorCategory from "./pages/Settings/Purchase_Management/Vendor_Category/VendorCategory";
      import VendorSubCategory from "./pages/Settings/Purchase_Management/Vendor_Sub_Category/VendorSubCategory";
      import BusinessType from "./pages/Settings/Purchase_Management/Business_Type/BusinessType";
      import UnitCategory from "./pages/Settings/Purchase_Management/Unit_Category/UnitCategory";

      import Score from "./pages/Settings/Purchase_Management/Score/Score";
      // Purchase Management
      import PaymentMode from "./pages/Settings/Payment_Management/Payment_Mode/PaymentMode";

    
      // Vehicle Management

      import VehicleCategory from "./pages/Settings/Vehicle_Management/Vehicle_Category/VehicleCategory";
      import ServiceType from "./pages/Settings/Vehicle_Management/Service_Type/ServiceType";
      import DocumentType from "./pages/Settings/Vehicle_Management/Document_Type/DocumentType";

      // HR Management

      import Department from "./pages/Settings/HR_Management/Department/Department";
      import ShiftTime from "./pages/Settings/HR_Management/Shift_Time/ShiftTime";
      import JobRole from "./pages/Settings/HR_Management/Job_Role/Job_Role";

      // Complaint Management

      import Complaint_Type from "./pages/Settings/Complaint_Management/Complaint_Type";

      // Accounts Management
      import Ledger from './pages/Settings/Account_Management/ledger/ledger'
      import SubLedger from './pages/Settings/Account_Management/Subledger/Subledger'

 
    import ItemCategory from "./pages/Settings/Package_Management/Item_Category/ItemCategory";
    import ItemSchedule from "./pages/Settings/Package_Management/Item_Schedule/ItemSchedule";
    import ItemSubCategory from "./pages/Settings/Package_Management/Item_Sub_Category/ItemSubCategory";
    import ProductCategory from "./pages/Settings/Package_Management/Product_Category/ProductCategory";
    import ProductType from "./pages/Settings/Package_Management/Product_Type/ProductType";
    import PackagePeriod from "./pages/Settings/Package_Management/Package_Period/PackagePeriod"; 

// ----------------------------------------------------------------------------------

//Purchase Management

// Manage Raw Materials
// import ManageRawMaterials from "./pages/Purchase_Management/Manage_Raw_Materials/RawMaterial";
import ManageRawMaterialss from "./pages/Purchase_Management/Manage_Raw_Materials/RawMaterials"; 

// Manage Vendors
import ManageVendors from "./pages/Purchase_Management/Manage_Vendor/Vendors";
import AddVendors from "./pages/Purchase_Management/Manage_Vendor/AddVendors";
import EditVendors from "./pages/Purchase_Management/Manage_Vendor/EditVendors";
import ViewVendors from "./pages/Purchase_Management/Manage_Vendor/ViewVendors";
// Manage Purchase
import ManagePurchase from "./pages/Purchase_Management/Manage_Purchase/Purchase";
import AddPurchase from "./pages/Purchase_Management/Manage_Purchase/AddPurchase";
import EditPurchase from "./pages/Purchase_Management/Manage_Purchase/EditPurchase";
import ViewPurchase from "./pages/Purchase_Management/Manage_Purchase/ViewPurchase"; 
import OverallPrintPage from './pages/Purchase_Management/Manage_Purchase/OverallPrintPage';
import Autopurchase from "../jsx/pages/Purchase_Management/Manage_Purchase/AutoPurchase"
// Purchase History
import PurchaseHistory from './pages/Purchase_Management/Purchase_History/PurchaseHistory'

// Manage Stock
import ManageStocks from "./pages/Purchase_Management/Manage_Stock/Stock";
import KitchenRoom from "./pages/Purchase_Management/Manage_Stock/KitchenRoom"; 
import StockChecklistHistory from "./pages/Purchase_Management/Manage_Stock/StockChecklistHistory";
import StockVessels from "./pages/Purchase_Management/Manage_Stock/StockVessels";
import MaangeStockConsumption from "./pages/Purchase_Management/Manage_Stock/StockConsumption";
import StockChecklist from './pages/Purchase_Management/Manage_Stock/StockChecklist'
import StockVerification from './pages/Purchase_Management/Manage_Stock/StockVerification'
import StockConsumption from './pages/Purchase_Management/Stock_Consumption/StockConsumption'

// Manage Pricebook
import ManagePricebook from "./pages/Purchase_Management/Manage_Pricebook/Pricebook";
import AmountEntryPurchase from "./pages/Purchase_Management/Manage_Purchase/AmtEntry";
import MarginCapital from "./pages/Settings/Production_Management/Margin_Capital/Margin_Capital";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
// import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
// import Toastr from "./components/PluginsMenu/Toastr/Toastr";

/// Form
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages

import Error404 from "./pages/Error404";
import { ThemeContext } from "../context/ThemeContext";

import HelpDesk from "./pages/Settings/HelpDesk";


import AddonService from './pages/Settings/Catering_Management/AddonService/AddonService';
import FunctionType from './pages/Settings/Catering_Management/FunctionType/FunctionType';
import CateringType from './pages/Settings/Catering_Management/CateringType/CateringType';

import ManageCustomer from './pages/Catering_Management/Manage_customer/Manage_Customer';
import ManageCateringOrder from "./pages/Catering_Management/Manage_Catering/Catering";
import CateringOrder from './pages/Catering_Management/Manage_customer/Catering_Order';
import ViewOrder from "./pages/Catering_Management/Manage_Catering/View_Order";
import CateringOrderEdit from "./pages/Catering_Management/Manage_Catering/Catering_Order_Edit";
import CateringOrderConfirm from "./pages/Catering_Management/Manage_Catering/Catering_Order_Confirm";

import PaymentList from './pages/Catering_Management/Manage_Payment/PaymentList';
import ManageCateringDelivery from './pages/Catering_Management/Manage_Delivery/ManageDelivery';


// Corp Order Management
import ManageCorporateOrder from "./pages/Corporate_Management/Manage_Corporate/Corporate";
import ManageCorporateCustomer from "./pages/Corporate_Management/Manage_Customer/Manage_Customer";
import ViewCorporateCustomer from "./pages/Corporate_Management/Manage_Customer/View_Corporate_Customer";
 
 
import CorporateOrder from "./pages/Corporate_Management/Manage_Customer/Corporate_Order";
import ViewCorporateOrder from "./pages/Corporate_Management/Manage_Corporate/View_Order";
import CorporateOrderEdit from "./pages/Corporate_Management/Manage_Corporate/Corporate_Order_Edit";
import CorporateOrderConfirm from "./pages/Corporate_Management/Manage_Corporate/Corporate_Order_Confirm";
 
import CorporatePaymentList from "./pages/Corporate_Management/Manage_Payment/PaymentList";
import CorpOnlinePayLink from './pages/Corporate_Management/Manage_Payment/PaymentOnline';
import ManageCorporateDelivery from "./pages/Corporate_Management/Manage_Delivery/ManageDelivery";


import OnlinePayLink from './pages/Catering_Management/Manage_Payment/PaymentOnline';
import AmountEntry from './pages/Purchase_Management/Manage_Purchase/AmtEntry'; 

// Purchase History
import Purchase from './pages/Purchase_Management/Purchase_History/PurchaseHistory';
import VendorPayment from "./pages/Purchase_Management/Manage_Vendor/VendorPayment"; 

import ManagePacking from './pages/Production_Management/Manage_Packing/Manage_Packing';
import ManagePackingCatering from './pages/Production_Management/Manage_Packing/Manage_Packing_Catering';
import ManagePackingCorporate from './pages/Production_Management/Manage_Packing/Manage_Packing_Corporate';
import Assign_Vessel_Cat from "./pages/Production_Management/Manage_Packing/Assign_Vessel_Cat";
import Assign_Vessel_Corp from "./pages/Production_Management/Manage_Packing/Assign_Vessel_Corp";
import View_Sub from "./pages/Production_Management/Manage_Packing/View_Sub";
import View_Cat_Packing from "./pages/Production_Management/Manage_Packing/View_Cat_Packing";
import View_Corp_Packing from "./pages/Production_Management/Manage_Packing/View_Corp_Packing";
import DeliverySubscription from "./pages/Production_Management/Manage_Packing/Delivermanagement";
import ManageHistory from "./pages/Payments_Management/Manage_History/History";
import StockOut from "./pages/Stock_Management/Stock_Out/Stock_Out";
import StockIn from "./pages/Stock_Management/Stock_In/Stock_In";
import ManageWeeklyConsumption from "./pages/Stock_Management/Weekly_Consumption/Weekly_Consumption";
import ManageKitchenConsumption from "./pages/Stock_Management/Weekly_Consumption/Kitchen_Consumption";

      import ManageDailyOrders from "./pages/Production_Management/Manage_Daily_Orders/Daily_Orders";
      import ManageDailyWork from "./pages/Production_Management/Manage_Daily_Orders/Daily_Work";
      import ManageDailyRework from "./pages/Production_Management/Manage_Daily_Orders/Rework";
      
// Monitoring Tools
import ManageUserLogs from "./pages/Monitoring_Tools/User_Logs/User_Logs";
import CronjobMonitor from "./pages/Monitoring_Tools/Cronjob_Monitor/CronjobMonitor";
import CallLog from "./pages/Monitoring_Tools/CallLog/CallLog";
import ManageMaintenanceMode from "./pages/Monitoring_Tools/Maintenance_Mode/Maintenance_Mode";
import Manage_Target from "./pages/KPI_Management/Manage_Target/Manage_Target";

const Markup = () => {

  const allroutes = [
      
  // Monitoring Tools
    { url: "manage-userlogs", component: <ManageUserLogs/> },
    { url: "cronjob-monitor", component: <CronjobMonitor /> },
    { url: "call-log-monitor", component: <CallLog /> },
    { url: "manage-maintenancemode", component: <ManageMaintenanceMode/> },
     { url: "kpi-manage-target", component: <Manage_Target/> },
    /// Dashboard

    { url: "", component: <Home /> },
    { url: "dashboard", component: <Home /> },
    { url: "manage-packing-delivery", component: <DeliverySubscription /> },
        
    { url: "margin-capital", component: < MarginCapital /> },
    
    { url: "manage-stockout", component: <StockOut/> },
    { url: "manage-stockin", component: <StockIn/> },
    { url: "manage-weeklyConsumption", component: <ManageWeeklyConsumption/> },

    
    { url: "manage-packing", component: <ManagePacking/>},
    { url: "manage-packing-catering", component: <ManagePackingCatering/>},
    { url: "manage-packing-corporate", component: <ManagePackingCorporate/>},
    { url: "assign-vessel-cat", component: <Assign_Vessel_Cat /> },
    { url: "assign-vessel-corp", component: <Assign_Vessel_Corp /> },
    { url: "view-subscription-packing", component: <View_Sub /> },
    { url: "view-catering-packing/:id", component: <View_Cat_Packing /> },
    { url: "view-corporate-packing/:id", component: <View_Corp_Packing /> },
    
    
    // Catering
    
    { url: "function-type", component: <FunctionType /> },
    { url: "catering-type", component: <CateringType /> },
    { url: "add-on-service", component: <AddonService /> },
    { url: "manage-catering-order", component: <ManageCateringOrder /> },
    { url: "catering-order-view", component: <ViewOrder /> },
    { url: "catering-order", component: <CateringOrder /> },
    { url: "catering-order-edit", component: <CateringOrderEdit /> },
    { url: "catering-order-confirm", component: <CateringOrderConfirm /> },
     
     { url: "manage-catering-customer", component: <ManageCustomer /> },
     { url: "view-catering-customer", component: <ViewCustomer /> },
     
   { url: "catering-payment", component: <PaymentList /> },
    { url: "catering-delivery", component: <ManageCateringDelivery /> },
    
    
     // Corp Order Management
    { url: "manage-corporate-order", component: <ManageCorporateOrder /> },
    { url: "corporate-order-view", component: <ViewCorporateOrder /> },
    { url: "corporate-order-edit", component: <CorporateOrderEdit /> },
    { url: "corporate-order-confirm", component: <CorporateOrderConfirm /> },
 
    { url: "manage-corporate-customer", component: <ManageCorporateCustomer /> },
    { url: "corporate-customer-view", component: <ViewCorporateCustomer /> },
    { url: "corporate-order", component: <CorporateOrder /> },
 
    { url: "corporate-payment", component: <CorporatePaymentList /> },
    { url: "corporate-delivery", component: <ManageCorporateDelivery /> },
        
{ url: "payments-history", component: <ManageHistory /> },
{ url: "manage-food-wastage", component: <ManageFoodWastage /> },    

    // ----------------------------------------------------------------------------------
    // Branch Management
    { url: "manage-branch", component: <ManageBranch /> },
    { url: "add-branch", component: <AddBranch /> },
    { url: "edit-branch", component: <EditBranch /> },
    { url: "manage-area", component: <ManageArea /> },
    { url: "manage-delivery-point", component: <ManageDeliveryPoint /> },
     { url: "manage-add-staff", component: <ManageAddStaff /> },
      { url: "help-desk", component: <HelpDesk />},
      
      { url: "subdepartment", component: <SubDepartment /> },
{ url: "level", component: <Level />},
      
      { url: "spam-reason", component: <SpamReason />},
        { url: "dead-reason", component: <DeadReason />},
        { url: "internal-call", component: <InternallCall />},
    // Lead Management

        // Manage Lead
        { url: "manage-lead", component: <ManageLead /> },
        { url: "lead-to-subscription", component: <LeadtoSubscription /> },
        { url: "manage-coupon", component: <ManageCoupon /> },
        { url: "redeem-points", component: <Redeem /> },
        
        // { url: "manage-delivery", component: <ManageDelivery /> },
        { url: "manage-tracking", component: <ManageTracking /> },
        { url: "manage-appointment", component: <ManageAppointment />},
    { url: "manage-followup", component: <ManageFollowup />},
        { url: "manage-calls", component: <ManageCalls /> },
    { url: "manage-calendar", component: <LeadCalendar /> },
    { url: "manage-source", component: <ManageLeadSource /> },
    
    { url: "quality-checklist-priority", component: < QualityChecklistPriority /> },
    { url: "item-staging-process", component: < ItemStagingProcess /> },
    // ----------------------------------------------------------------------------------

{ url: "manage-product-quantity", component: <ViewProductQuantity /> },
    // ----------------------------------------------------------------------------------
      // Subcriber Management

        // Manage Customers
        { url: "manage-subscribers", component: <ManageSubscribers /> },
        { url: "view-subscribers", component: <ViewSubscribers /> },
        { url: "food-map", component: <FoodMap /> },
        { url: "new-subscriptions", component: <NewSubscriptions /> },
        //  { url: "amt-entry-purchase", component: <AmtEntryPurchase /> },
         { url: "manage-cloud-call", component: <ManageCloudCall /> },

    // ----------------------------------------------------------------------------------

    // Team Management
    { url: "team-lead", component: <TeamLead /> },
    { url: "team-followup", component: <TeamFollowup /> },
    { url: "team-appointment", component: <TeamAppointment /> },
    { url: "team-call", component: <TeamCall /> },
    { url: "team-promise", component: <TeamPromise /> },
    { url: "team-monthly-promise", component: <TeamPromiseMonth /> },


    { url: "manage-order", component: <ManageOrder /> },
    { url: "add-subscriptions/:ID", component: <AddSubscriptions /> },
    { url: "view-subscriber-details", component: <ViewSubscriberDetails /> },


    // Subscription Management
        // Manage Subscriptions
        { url: "manage-subscriptions", component: <ManageSubscription /> },
        // { url: "add-subscriptions", component: <AddSubscription /> },
        { url: "manage-subscriptions-convert", component: <ConvertSubscriber /> },
        { url: "manage-subscriptions-renew", component: <RenewSubscription /> },
        { url: "manage-subscribers-convert", component: <ConvertnewSubscriber /> },

// hold
        { url: "manage-hold", component: <ManageHold /> },
        // Manage Drop
        { url: "manage-drop", component: <ManageDrop /> },
        
        { url: "manage-closed-followup", component: <ClosedFollowup />},
    { url: "manage-reschedule-followup", component: <RescheduleFollowup />},
    { url: "manage-unfollowup", component: <UnFollowup />},
    
    { url: "manage-spam-lead", component: <SpamLead /> },
    { url: "manage-dead-lead", component: <DeadLead /> },
    { url: "manage-internal-call", component: <InternalCall /> },
    { url: "manage-today-followup", component: <TodayFollowup /> },
    { url: "followup-reason", component: <Followupreason /> },

    // ----------------------------------------------------------------------------------

    // Packages Management
       
        // Manage Products
        { url: "manage-products", component: <ManageProducts /> },
        { url: "add-products", component: <AddProduct /> },
        { url: "edit-products", component: <EditProduct /> },
  

        // Manage Packages
        { url: "manage-packages", component: <ManagePackages /> },

        // Manage Menu Maker
        { url: "manage-menumaker", component: <ManageMenuMaker /> },
        { url: "add-menumaker", component: <AddMenuMaker /> },
        { url: "edit-menumaker", component: <EditMenuMaker /> },

    // ----------------------------------------------------------------------------------

    // Payments Management
        { url: "payments-management", component: <ManagePayments /> },
        { url: "payments-management-catering", component: <CateringPayments />},
        { url: "payments-management-corporate", component: <CorporatePayments />},
        { url: "manage-refund", component: <ManageRefund /> },
        { url: "manage-refund-catering", component: <CateringRefund /> },
        { url: "manage-refund-corporate", component: <CorporateRefund /> },

    // ----------------------------------------------------------------------------------

   // Purchase Management

    // Manage Raw Materials
    // { url: "manage-rawmaterials", component: <ManageRawMaterials /> },
    { url: "manage-rawmaterials", component: <ManageRawMaterialss /> }, 
    // Manage Vendors
    // { url: "manage-vendors", component: <ManageVendors /> },
    // { url: "add-vendors", component: <AddVendors /> },
    // { url: "edit-vendors", component: <EditVendors /> },
    // { url: "view-vendors", component: <ViewVendors /> },
    
    // Manage Machinery
    { url: "manage-machinery", component: <ManageMachinery /> },
    { url: "manage-machinery-add", component: <AddMachinery /> },
    { url: "manage-machinery-view", component: <ViewMachinery /> },
    { url: "manage-machinery-edit", component: <EditMachinery /> },
    
    
    
    
           // Manage Vendors
        { url: "manage-vendors", component: <ManageVendors /> },
        { url: "add-vendors", component: <AddVendors /> },
        { url: "edit-vendors", component: <EditVendors /> }, 
        { url: "view-vendors", component: <ViewVendors /> },
        //  { url: "edit-vendors/:sno", component: <EditVendors /> }, 
        // { url: "view-vendors/:sno", component: <ViewVendors /> },
        { url: "vendor-payment", component: <VendorPayment /> },
        { url: "manage-forecast-metrics", component: <Manage_Forecast_Metrics/> },

        // Manage Purchase 
        { url: "manage-purchase", component: <ManagePurchase /> },
        { url: "add-purchase", component: <AddPurchase /> }, 
        { url: "edit-purchase", component: <EditPurchase /> },
        { url: "view-purchase", component: <ViewPurchase /> },
        { url: "amt-entry-purchase", component: <AmountEntry /> }, 
        { url: "auto-purchase", component: <Autopurchase /> },

        // Purchase History

        { url: "purchase-history", component: <Purchase />},
 
        // Manage Pricebook
        { url: "manage-pricebook", component: <ManagePricebook /> },
        
        // Manage Stocks
         // Manage Stocks
        { url: "manage-stocks", component: <ManageStocks /> },
        { url: "manage-stocks-checklist-history", component: <StockChecklistHistory /> },
        { url: "manage-stocks-vessels", component: <StockVessels /> },
        { url: "manage-stocks-consumption", component: <MaangeStockConsumption /> },

        { url: "stocks-checklist", component: <StockChecklist /> },
        { url: "stock-consumption", component: <StockConsumption /> },  
        
        { url: "manage-staff-exit", component: <ManageExitStaffs /> },
        
        // { url: "manage-stocks", component: <ManageStocks /> },
        // { url: "stocks-checklist", component: <StockChecklist /> },
        // { url: "stock-consumption", component: <StockConsumption /> },  
        
    // Manage Purchase
    // { url: "manage-purchase", component: <ManagePurchase /> },
    // { url: "add-purchase", component: <AddPurchase /> },
    // { url: "edit-purchase", component: <EditPurchase /> },
    // { url: "view-purchase", component: <ViewPurchase /> },
    // Purchase History
    // { url: "purchase-history", component: <PurchaseHistory /> },
    // Manage Stocks
  
    // Manage Pricebook
    // { url: "manage-pricebook", component: <ManagePricebook /> },
    
 
    // ----------------------------------------------------------------------------------

    // Productions Management

        // Manage Items
        { url: "manage-items", component: <ManageItems /> },
        { url: "add-items", component: <AddItems /> },
        { url: "edit-items", component: <EditItems /> },
        { url: "view-items", component: <ViewItems /> },

        // Manage Daily Order
        { url: "manage-daily-orders", component: <ManageDailyOrders /> },

        // Manage Works
        { url: "manage-works", component: <ManageWorks /> },

        // Manage Quality Analysis
        { url: "manage-quality-analysis", component: <ManageQualityAnalysis /> },
    
    // ----------------------------------------------------------------------------------

    // Vehicle Management

        // Manage Vehicle
        { url: "manage-vehicles", component: <ManageVehicles /> },
        { url: "add-vehicle", component: <AddVehicle /> },
        { url: "edit-vehicle", component: <EditVehicle /> },
        { url: "view-vehicle", component: <ViewVehicle /> },

        // Manage Maintenance
        { url: "manage-maintenance", component: <ManageMaintenance /> },

    // ----------------------------------------------------------------------------------
        
    // Delivery Management

        // Manage Tripsheet
        { url: "manage-tripsheet", component: <ManageTripsheet /> },

        // Manage Delivery
        { url: "manage-delivery", component: <ManageDelivery /> },

    // ----------------------------------------------------------------------------------

    // Complaints Management

        // Manage Tripsheet
        { url: "manage-complaints", component: <ManageComplaints /> },

    // ----------------------------------------------------------------------------------

    // Catering Management

        // Manage Catering
        { url: "manage-catering", component: <ManageCatering /> },

    // ----------------------------------------------------------------------------------

    // Corporate Management

        // Manage Corporate
        { url: "manage-corporate", component: <ManageCorporate /> },
        
    // ----------------------------------------------------------------------------------
        { url: "manage-kitchenConsumption", component: <ManageKitchenConsumption/>},
         { url: "manage-kitchenroom", component: <KitchenRoom /> },
            { url: "stocks-verification", component: <StockVerification /> },
        
    // HR Management

        // Manage Staffs
        { url: "manage-staff", component: <ManageStaffs /> },
        { url: "add-staff", component: <AddStaff /> },
        { url: "edit-staff", component: <EditStaff /> },
        { url: "view-staff", component: <ViewStaff /> },

        // Manage Attendance
        { url: "manage-attendance", component: <Attendance /> },
        { url: "add-attendance", component: <AddAttendance /> },
        
        // Manage Payouts
        { url: "manage-payouts", component: <Payouts /> },
        
    // ----------------------------------------------------------------------------------

    // Accounts Management

        // Manage Daily Accounts
        { url: "daily-accounts", component: <DailyAccounts /> },

        // Manage Profit & Loss
        { url: "profit-loss", component: <ProfitLoss /> },
        
        // Manage Trial Balance
        { url: "trial-balance", component: <TrialBalance /> },

    // ----------------------------------------------------------------------------------

    // Users Management
        
        { url: "users-manage", component: <ManageUsers/> },

        // Manage Users role
        { url: "manage-users-role", component: <ManageUsersrole /> },
        { url: "add-users", component: <AddUsers /> },
        { url: "edit-users", component: <EditUsers /> },
        { url: "view-users", component: <ViewUsers /> },

        // Manage User Role
        // { url: "manage-user-role", component: <ManageUserRole /> },

    // ----------------------------------------------------------------------------------

       // Settings

        // Manage Lead Source
        { url: "lead-source", component: <LeadSource /> },

        // Manage Lead Type
        { url: "lead-type", component: <LeadType /> },

        // Manage Potential Type
        { url: "lead-status", component: <LeadStatus /> },
        
        { url: "leave-type", component: <LeaveType /> },
        { url: "menu", component: <MenuManagement /> },

    // ----------------------------------------------------------------------------------
    { url: "cookware_category", component: <CookwareCategory /> },
    { url: "cookware_subcategory", component: <CookwareSubcategory /> },
    { url: "cookware_material", component: <CookwareMaterial /> },
    { url: "cookware", component: <Cookware /> },
    { url: "mechinery-category", component: <MechCatego /> },

      // Settings

        { url: "general-settings", component: <GeneralSettings /> },
        { url: "settings", component: <Settings /> },
        { url: "holiday", component: <Holiday />},
        { url: "banner", component: <Banner />},
        { url: "meals-point", component: <MealsPoint />},
        // { url: "add-on-service", component: <AddonService /> },

        // Common Settings
        
        { url: "country", component: <Country /> },
        { url: "state", component: <State /> },
        { url: "city", component: <City /> },
        { url: "timezoneformat", component: < TimeZoneFormat /> },
        { url: "currencyformat", component: < CurrencyFormat /> },
        { url: "language", component: < Language /> },

        // Lead Managemnt

        { url: "lead-type", component: <LeadType /> },
        { url: "lead-source", component: <LeadSource /> }, 
        { url: "lead-status", component: <LeadStatus /> },

        // Subscription
        { url: "drop-reason", component: <DropReason /> },

        // Production Management
        { url: "temperature", component: < Temperature /> },
        { url: "duration", component: < Duration /> },
        { url: "preparation-category", component: < PreparationCategory /> },
        { url: "item-property", component: < Property /> },
        { url: "item-property-type", component: < PropertyType /> },
        { url: "manage-menumaker", component: <ManageMenuMaker /> },
        { url: "add-menumaker", component: <AddMenuMaker /> },
        { url: "edit-menumaker", component: <EditMenuMaker /> },
        { url: "manage-item-quantity", component: <ViewItemQuantity /> },
           // Menu Maker
    { url: "menu-maker", component: <MenuMaker /> },
    // Manage Daily Order
    // { url: "manage-daily-orders", component: <ManageDailyOrders /> },
    // Manage Works
    { url: "manage-work-assignment", component: <ManageWorks /> },
    // Manage Quality Analysis
    { url: "manage-quality-analysis", component: <ManageQualityAnalysis /> },
    // Manage Wastage
    { url: "manage-wastage", component: <ManageWastage /> },
    // Manage Wastage
    { url: "manage-production-costing", component: <ManageProductionCosting /> },
    
    // Manage Daily Order
        { url: "manage-daily-orders", component: <ManageDailyOrders /> },
        { url: "manage-daily-orders-work", component: <ManageDailyWork /> },
        { url: "manage-daily-orders-rework", component: <ManageDailyRework /> },

        // Manage Daily Order
        // { url: "manage-daily-orders", component: <ManageDailyOrders /> },

        // Manage Works
        { url: "manage-works", component: <ManageWorks /> },

        // Manage Quality Analysis
        { url: "manage-quality-analysis", component: <ManageQualityAnalysis /> },
      
        // Payment Management
        { url: "payment-mode", component: <PaymentMode /> },

        // Purchase Managemnt

        { url: "raw-material-category", component: < RawMaterialCategory /> },
        { url: "raw-material-sub-category", component: < RawMaterialSubCategory /> },
        { url: "units", component: <Units /> },
        { url: "vendor-category", component: < VendorCategory /> },
        { url: "vendor-sub-category", component: < VendorSubCategory /> },
        { url: "business-type", component: < BusinessType /> },
         { url: "unit-category", component: < UnitCategory /> },
        { url: "score", component: <Score /> },
        // Vehicle Management

        { url: "vehicle-category", component: < VehicleCategory /> },
        { url: "service-type", component: < ServiceType /> },
        { url: "document-type", component: < DocumentType /> },
      
        // HR Management

        { url: "department", component: <Department /> },
        { url: "shift-time", component: <ShiftTime /> },
        { url: "job-role", component: <JobRole /> },

        // Complaint Management

        { url: "complaint-type", component: <Complaint_Type /> },

        // Accounts Management

        { url: "ledger", component: < Ledger /> },
        { url: "sub-ledger", component: < SubLedger /> },

        // Package Management 
  
          { url: "item-category", component: < ItemCategory /> },
          { url: "item-schedule", component: < ItemSchedule /> },
          { url: "item-sub-category", component: < ItemSubCategory /> },
          { url: "product-category", component: <ProductCategory /> },
          { url: "product-type", component: <ProductType /> },
          { url: "package-period", component: <PackagePeriod /> },

         { url: "catcorpmenu", component: <ManageCatCorpMenu />},
    { url: "pages-sample", component:<Pages />},
    // ----------------------------------------------------------------------------------
  
    ///// Plugin
    { url: "uc-select2", component: <Select2 /> },


    ///// Form
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },
    //

  ];


  return (
    <>
      <Routes>
        <Route path='page-error-404' element={<Error404 />} />
        <Route path='trip-sheet-print' element={<PrintTripsheet />} />
        <Route element={<MainLayout />} >
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
        <Route path='subscription_payment' element={<SubscriptionOnlinePayment />} />
        <Route path='menu-maker-print' element={<MenuMakerPrint />} />
        <Route path='online-payment' element={<OnlinePayLink />} />
        <Route path='online-payment-corp' element={<CorpOnlinePayLink />} />
         <Route path='overall-print-page' element={<OverallPrintPage />} />
      </Routes>
      <ScrollToTop />

    </>
  );
};
<div className="page d-flex flex-row flex-column-fluid">

</div>

function MainLayout() {
  const { menuToggle } = useContext(ThemeContext);
  return (
    <div className="page d-flex flex-row flex-column-fluid flex-column mw-100">
      <div id="main-wrapper" className={`wrapper d-flex flex-column flex-row-fluid show ${menuToggle ? "menu-toggle" : " "}`}>
        <div className="content d-flex flex-column flex-column-fluid min-vh-100">
          <Nav />
          <div className="content-body min-h-100 h-100" style={{ flex: 1 }}>
            <div className="container mw-unset mh-100 mt-2 px-4">
              <Outlet />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  )

};

export default Markup;
